import axios from 'axios'
import { URLS } from '../../util/urls'
import debugHelper from '../../util/debug'
import tools from '../../util/tools'

const state = {
  sessions: [],// 会话消息列表
  messages: [],// 会话对应的消息列表

  sessionTotalCount: 0, // 会话消息总数
  messageTotalCount: 0, // 消息总数

  listRecordCount: 0, // 已经加载的记录数

  messageUnreadNum: 0, // 消息未读数量
  messageInfo: null, // 单条消息信息

  sessionFilter: '', // 会话过滤条件

  currentSession: null, // 当前的会话
}

const getters = {
  getSessions: state => {
    if (state.sessions != null) {
      return state.sessions
    }
  },
  getMessages: state => {
    if (state.messages != null) {
      return state.messages
    }
  },
  getSessionTotalCount: state => {
    return state.messageSessionTotal
  },
  getMessageTotalCount: state => {
    return state.messageTotalCount
  },
  getMessageUnreadNum: state => { // 暂无调用点
    return state.messageUnreadNum
  },
  getMessageInfo: state => {
    return state.messageInfo
  },
  getCurrentSession: state => {
    return state.currentSession
  },
}

const actions = {
  fetchSessions: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: URLS.EDS_USERS_SESSIONS_URL,
        params: params.data,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          commit('setSessions', {
            value: resp.data
          })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'message:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },
  appendSessions: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: URLS.EDS_USERS_SESSIONS_URL,
        params: params.data,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          commit('appendSessions', {
            value: resp.data
          })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'message:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },
  fetchMessages: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: URLS.EDS_USERS_SESSIONS_URL + '/' + params.sessionID + '/msgs',
        params: params.data,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          commit('setMessages', {
            value: resp.data
          })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'message:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },
  appendMessages: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: URLS.EDS_USERS_SESSIONS_URL + '/' + params.sessionID + '/msgs',
        params: params.data,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          commit('appendMessages', {
            value: resp.data
          })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'message:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },
  // 读取消息未读数量
  fetchMsgForBadge: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      // ......
    })
  },
}

const mutations = {
  setSessions: (state, payload) => {
    state.sessionTotalCount = payload.value.total
    state.sessions.splice(0, state.sessions.length) // 清空数组
    if (payload.value.data) {
      payload.value.data.forEach(session => {
        state.sessions.push(session)
      })
    }
  },
  appendSessions: (state, payload) => {
    state.sessionTotalCount = payload.value.total
    payload.value.data.forEach(session => {
      state.sessions.push(session)
    })
  },
  setMessages: (state, payload) => {
    state.messageTotalCount = payload.value.total
    state.messages.splice(0, state.messages.length) // 清空数组
    if (payload.value.data) {
      payload.value.data.forEach(message => {
        state.messages.push(message)
      })
    }
  },
  appendMessages: (state, payload) => {
    state.messageTotalCount = payload.value.total
    payload.value.data.forEach(message => {
      state.messages.push(message)
    })
  },
  setMessageUnreadNum: (state, payload) => { // 暂无调用点
    state.messageUnreadNum = payload.value.total
  },
  setMessageInfo: (state, payload) => {
    state.messageInfo = payload.value
  },
  setCurrentSession: (state, payload) => {
    state.currentSession = payload.value
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
